// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-assistants-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 20px;
}

.assistant-box {
    background-color: #144040;
    color: white;
    padding: 15px;
    border-radius: 15px;
    text-align: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s, box-shadow 0.2s;
    margin: 10px;
    flex: 1 1 30%; /* Allow boxes to take up about 30% of the row width */
    max-width: 300px; /* Ensure a max width */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
}

.assistant-box:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.assistant-image-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}

.assistant-image {
    width: 150px; /* Set a fixed width */
    height: 150px; /* Set a fixed height */
    object-fit: contain;
    border-radius: 10px; /* Adds round edges to the image */
}

.assistant-content h5 {
    margin-top: 10px;
    font-size: 18px;
    font-weight: bold;
}

.assistant-content p {
    font-size: 14px;
    color: #Dcca98;
}

/* Media Queries for Responsiveness */

/* Large screens (desktops, 1200px and up) */
@media (min-width: 1200px) {
    .assistant-box {
        flex: 1 1 23%; /* 4 items per row */
    }
}

/* Medium screens (tablets, 768px to 1199px) */
@media (min-width: 768px) and (max-width: 1199px) {
    .assistant-box {
        flex: 1 1 48%; /* 2 items per row */
    }
}

/* Small screens (phones, 576px to 767px) */
@media (min-width: 576px) and (max-width: 767px) {
    .assistant-box {
        flex: 1 1 100%; /* 1 item per row */
    }
}

/* Extra small screens (less than 576px) */
@media (max-width: 575px) {
    .assistant-box {
        flex: 1 1 100%; /* 1 item per row */
    }
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/CSS/dashboardAssistants.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,2CAA2C;IAC3C,YAAY;IACZ,aAAa,EAAE,sDAAsD;IACrE,gBAAgB,EAAE,uBAAuB;IACzC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,sBAAsB;IACpC,aAAa,EAAE,uBAAuB;IACtC,mBAAmB;IACnB,mBAAmB,EAAE,kCAAkC;AAC3D;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,qCAAqC;;AAErC,4CAA4C;AAC5C;IACI;QACI,aAAa,EAAE,oBAAoB;IACvC;AACJ;;AAEA,8CAA8C;AAC9C;IACI;QACI,aAAa,EAAE,oBAAoB;IACvC;AACJ;;AAEA,2CAA2C;AAC3C;IACI;QACI,cAAc,EAAE,mBAAmB;IACvC;AACJ;;AAEA,0CAA0C;AAC1C;IACI;QACI,cAAc,EAAE,mBAAmB;IACvC;AACJ","sourcesContent":[".dashboard-assistants-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    padding: 20px;\n}\n\n.assistant-box {\n    background-color: #144040;\n    color: white;\n    padding: 15px;\n    border-radius: 15px;\n    text-align: center;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    transition: transform 0.2s, box-shadow 0.2s;\n    margin: 10px;\n    flex: 1 1 30%; /* Allow boxes to take up about 30% of the row width */\n    max-width: 300px; /* Ensure a max width */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.assistant-box:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n}\n\n.assistant-image-container {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 10px;\n}\n\n.assistant-image {\n    width: 150px; /* Set a fixed width */\n    height: 150px; /* Set a fixed height */\n    object-fit: contain;\n    border-radius: 10px; /* Adds round edges to the image */\n}\n\n.assistant-content h5 {\n    margin-top: 10px;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.assistant-content p {\n    font-size: 14px;\n    color: #Dcca98;\n}\n\n/* Media Queries for Responsiveness */\n\n/* Large screens (desktops, 1200px and up) */\n@media (min-width: 1200px) {\n    .assistant-box {\n        flex: 1 1 23%; /* 4 items per row */\n    }\n}\n\n/* Medium screens (tablets, 768px to 1199px) */\n@media (min-width: 768px) and (max-width: 1199px) {\n    .assistant-box {\n        flex: 1 1 48%; /* 2 items per row */\n    }\n}\n\n/* Small screens (phones, 576px to 767px) */\n@media (min-width: 576px) and (max-width: 767px) {\n    .assistant-box {\n        flex: 1 1 100%; /* 1 item per row */\n    }\n}\n\n/* Extra small screens (less than 576px) */\n@media (max-width: 575px) {\n    .assistant-box {\n        flex: 1 1 100%; /* 1 item per row */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
